import { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import SimplePagination from "../../../components/SimplePagination";
import { CustomSortIcon } from "../../../components/DatatableHelpers";
import Select from "../../../components/input/Select";
import {
	PeerReviewRequestViewModel,
	PeerReviewActivityPerWriterViewModel,
} from "../peerReviewsApiSlice";
import {
	actionBodyTemplate,
	draftNumberBodyTemplate,
	matchesStatus,
	reviewDateBodyTemplate,
	statusBodyTemplate,
	statusIconBodyTemplate,
	statusOptions,
	studentNameBodyTemplate,
} from "./PeerReviewActivityUtil";

export default function ReviewRequestInfoExpansionRow({
	requesterData,
}: {
	requesterData: PeerReviewActivityPerWriterViewModel;
}) {
	const [page, setPage] = useState(0);
	const [selectedStatus, setSelectedStatus] = useState<string>("All");

	// Filtering
	const filteredRequests = requesterData.requests.filter((request) => {
		return matchesStatus(request.reviewStatus, selectedStatus);
	});

	// Pagination
	const pageSize = 10;
	const handlePageChange = (newPage: number) => {
		setPage(newPage);
	};

	const totalCount = filteredRequests.length;
	const paginatedReviewRequests = filteredRequests.slice(page * pageSize, (page + 1) * pageSize);

	return (
		<div className="p-4 bg-white -mx-4 -my-3">
			<Select
				value={selectedStatus}
				setValue={(value) => setSelectedStatus(value as string)}
				simpleListBoxId="status-filter"
				options={statusOptions}
				label="Status"
				fieldClasses="w-64 mb-4"
			/>
			<DataTable
				value={paginatedReviewRequests}
				stripedRows
				sortIcon={CustomSortIcon}
				emptyMessage="No review requests found"
				className="tbl tbl-datatable -mb-2">
				<Column
					header="Reviewer"
					sortField="reviewer.formalFullName"
					body={(rowData: PeerReviewRequestViewModel) =>
						studentNameBodyTemplate(rowData.reviewer)
					}
					sortable
				/>
				<Column
					body={statusIconBodyTemplate}
					headerClassName="!px-0 w-4"
					className="!px-0"></Column>
				<Column
					header="Status"
					field="isReviewed"
					body={statusBodyTemplate}
					sortable
					headerClassName="writing:w-[266px] !px-1"
					className="!px-1"
				/>
				<Column
					header="Draft Reviewed"
					field="reviewedDraftNumber"
					body={(rowData: PeerReviewRequestViewModel) =>
						draftNumberBodyTemplate(rowData.reviewedDraftNumber)
					}
					sortable
				/>
				<Column
					header="Review Date"
					field="reviewDate"
					body={reviewDateBodyTemplate}
					style={{ minWidth: "120px" }}
					sortable
				/>
				<Column body={actionBodyTemplate} headerClassName="w-16" />
			</DataTable>
			{totalCount > pageSize && (
				<SimplePagination
					itemCount={totalCount}
					page={page}
					pageSize={pageSize}
					totalCount={totalCount}
					onChange={(page) => handlePageChange(page)}
					className="border-none"
				/>
			)}
		</div>
	);
}
